module.exports = __webpack_public_path__ + "img/alert-image.5cdcd206.png";